export default "__VITE_ASSET__Cq7sZk6C__"